import { collection, getDocs, orderBy, query, where } from "firebase/firestore";
import { getLocalStorageItem } from "../../../controllers/localStorage/getLocalStorage";
import { db } from "../../../firebase";

const GetAllLeadsFromDeals = async (filterBy) => {
  try {
    const dealsCollection = collection(db, "deals");
    let q;

    q =
      filterBy === "*"
        ? query(
            dealsCollection,
            where("is_deleted", "==", false),
            where("bid", "==", getLocalStorageItem("bid")),
            orderBy("createdAt", "desc")
          )
        : query(
            dealsCollection,
            where("is_deleted", "==", false),
            where("bid", "==", getLocalStorageItem("bid")),
            where("currentstatus", "==", filterBy),
            orderBy("createdAt", "desc")
          );

    const dealsSnapshot = await getDocs(q);

    let leads = [];
    dealsSnapshot.forEach((deal) =>
      leads.push({
        currentstatus: deal.data().currentstatus,
        ...deal.data().client,
      })
    );

    let uniqueLeadsIds = [];

    let uniqueLeadsList = [];

    const uniqueLeads = leads.map((element, index) => {
      console.log("element element: ", element);
      const isDuplicate = uniqueLeadsIds.includes(element.email);

      if (!isDuplicate) {
        uniqueLeadsIds.push(element.email);
        uniqueLeadsList.push(element);
        return true;
      }

      return false;
    });
    return uniqueLeadsList;
  } catch (error) {
    console.log(error);
  }
};

export default GetAllLeadsFromDeals;
